import { Card, CardBody, CardHeader, Text } from '@backstage/ui';
import type { CheckDefinition } from '@internal/backstage-plugin-pulse-common';
import { checkToYaml } from '../../../checks/check-yaml';

type CheckYamlPreviewProps = {
  check: CheckDefinition;
};

export const CheckYamlPreview = ({ check }: CheckYamlPreviewProps) => (
  <Card>
    <CardHeader>
      <Text variant="title-x-small">{`Check: ${check.name}`}</Text>
    </CardHeader>
    <CardBody>
      <pre
        style={{
          margin: 0,
          maxHeight: '40vh',
          overflow: 'auto',
          fontSize: '0.8125rem',
          whiteSpace: 'pre',
        }}
      >
        {checkToYaml(check)}
      </pre>
    </CardBody>
  </Card>
);
